module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (62).92be5503.jpg";